<div [formGroup]="parent">
  <div class="form-field" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}" role="textbox" [attr.aria-describedby]="'lbl-'+controllerData['name']">

    <label for="{{controllerData['name']}}" class="form-label" [id]="'lbl-'+controllerData['name']">{{controllerData['label']}}</label>
    <div class="form-field-text">
      <input [formControlName]="controllerData['controlName']" [name]="controllerData['name']" type="text" [id]="controllerData['name']"
      [(ngModel)]="textValue" aria-invalid="false" [placeholder]="controllerData['placeHolder']" [maxlength]="controllerData['maxlength']"
        class="form-control" [required]="controllerData['required']" (blur)="inputTextChangeHandler($event.target.value)"
        (keyup.enter)="inputTextChangeHandler($event.target.value)"
       
        [value]="(pageName !== 'register') ? parent.get([controlName]).value
    : parent.get([controlName]).value | capitalize"/>

    </div>



    <div [id]="controlName +'-error'" class="form-validation-error" *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors">
      <i class="icon icon-error" aria-hidden="true"></i>
      <p *ngIf="parent.get(controlName).touched
                        &&
                      parent.get(controlName).hasError('required')" [id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>
      <p *ngIf="parent.get(controlName).touched
                         &&
                      parent.get(controlName).hasError('notValidname')" [id]="controlName +'-invalid-error'">
        {{controllerData['errorMessageInvalid']}}
      </p>
      <p *ngIf="parent.get(controlName).touched
            &&
         !parent.get(controlName).hasError('notValidname')
         &&
         parent.get(controlName).errors.pattern">{{controllerData['errorMessageInvalid']}}</p>
    </div>
  </div>
</div>